/**
 * features/documents/types.ts — โครงข้อมูลฟอร์มที่ใช้ร่วมกันทั้งสองเอกสาร
 */

export interface DocumentItemDraft {
  productName: string;
  description: string;
  quantity: number;
  unit: string;
  unitPrice: number;
  discount: number;
}

export interface DocumentFormState {
  date: string;
  customerId: string | null;
  customerName: string;
  customerAddress: string;
  customerTaxId: string;
  customerBranch: string;
  customerPhone: string;
  discountAmount: number;
  notes: string;
  items: DocumentItemDraft[];
}

export const EMPTY_DOCUMENT_FORM: DocumentFormState = {
  date: new Date().toISOString().slice(0, 10),
  customerId: null,
  customerName: '',
  customerAddress: '',
  customerTaxId: '',
  customerBranch: '',
  customerPhone: '',
  discountAmount: 0,
  notes: '',
  items: [{ productName: '', description: '', quantity: 1, unit: 'ชิ้น', unitPrice: 0, discount: 0 }],
};
